// extracted by mini-css-extract-plugin
export default {"price":"K6-z","onSale":"L6-z","msrpLabelPrice":"M6-z","msrpLabel":"N6-z","originalPrice":"O6-z","percentOff":"P6-z"};